import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './returnChips.module.css';

const ReturnChips = ({ chips }) => {
  const navigate = useNavigate();
  if (!chips || chips.length === 0) return null;

  return (
    <div className={styles.row}>
      {chips.map((chip) => (
        <button
          key={`${chip.id}-${chip.sourceLineId || 'source'}`}
          type="button"
          className={styles.chip}
          aria-label={`Returned ${chip.returnNo}`}
          onClick={() => navigate(`/inventory/supplier-returns/${chip.id}`)}
        >
          {chip.returnNo}
        </button>
      ))}
    </div>
  );
};

ReturnChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      returnNo: PropTypes.string,
      sourceLineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
};

ReturnChips.defaultProps = {
  chips: [],
};

export default ReturnChips;
